import { List, RemovedItem, Create, Edit, Barcode } from "../Components/index.js";

export default [
    {
        path: "/fd/inventory/item",
        component: List,
        name: "fd.inventory.item",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/inventory/item-removed",
        component: RemovedItem,
        name: "fd.inventory.item.removed",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/inventory/barcode/show",
        component: Barcode,
        name: "fd.inventory.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/inventory/item/create",
        component: Create,
        name: "fd.inventory.item.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/inventory/item/:id/edit",
        component: Edit,
        name: "fd.inventory.item.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
